/* Selector de subtipo estructurado (QA-006): se muestra solo cuando la categoría define `rules.subtypes`
 * ({ label, required, options: [{ code, name }] }). El backend valida el código contra las reglas de la categoría. */
import { Field } from '@/shared/ui';

export type SubtypeOption = { code: string; name?: string };
export type SubtypeRules = { label: string; required: boolean; options: SubtypeOption[] };

export function subtypeRules(rules: Record<string, unknown> | null | undefined): SubtypeRules | null {
  const st = rules?.subtypes as Partial<SubtypeRules> | undefined;
  const options = Array.isArray(st?.options) ? st.options.filter((o) => o && typeof o.code === 'string' && o.code) : [];
  return options.length ? { label: st?.label || 'Subtipo', required: !!st?.required, options } : null;
}

export function SubtypeSelect({ rules, value, onChange, id = 'xsub', disabled }: { rules: Record<string, unknown> | null | undefined; value: string | null; onChange: (code: string | null) => void; id?: string; disabled?: boolean }) {
  const st = subtypeRules(rules);
  if (!st) return null;
  const known = value && st.options.some((o) => o.code === value);
  return (
    <Field label={`${st.label}${st.required ? '' : ' (opcional)'}`} htmlFor={id} hint={!known && st.required ? 'Obligatorio para esta categoría' : undefined}>
      <select id={id} value={known ? value! : ''} disabled={disabled} required={st.required} onChange={(e) => onChange(e.target.value || null)} style={{ height: 44, width: '100%', maxWidth: '100%', fontSize: 'var(--fs-md)' }} data-testid="subtype-select">
        <option value="">{st.required ? 'Selecciona…' : '—'}</option>
        {st.options.map((o) => <option key={o.code} value={o.code}>{o.name ?? o.code}</option>)}
      </select>
    </Field>
  );
}
